import { useTranslation } from '../i18n';
import React, { useState, useEffect } from 'react';
import { Space, Typography, Button, Tooltip, message } from 'antd';
import { EyeOutlined, EyeInvisibleOutlined, CopyOutlined } from '@ant-design/icons';

const { Text } = Typography;

/**
 * 敏感值展示：默认打码，需显式点「显示」才明文，复制不需要先显示。
 * 用于 VM root/VNC 密码等。value 变化（如改密后刷新）时自动重新打码。
 */
const SecretText = ({ value, emptyText = '-', mask = '••••••••' }) => {
    const { t } = useTranslation();
    const [revealed, setRevealed] = useState(false);

    useEffect(() => {
        setRevealed(false);
    }, [value]);

    if (value === null || value === undefined || value === '') {
        return <Text type="secondary">{emptyText}</Text>;
    }

    const copy = async () => {
        try {
            await navigator.clipboard.writeText(String(value));
            message.success(t('Copied'));
        } catch (e) {
            message.error(t('Failed to copy. Please reveal the content first, then copy it manually.'));
        }
    };

    return (
        <Space size={4}>
            <Text code style={{ userSelect: revealed ? 'text' : 'none' }}>
                {revealed ? String(value) : mask}
            </Text>
            <Tooltip title={revealed ? t('Hide') : t('Show')}>
                <Button
                    type="link"
                    size="small"
                    icon={revealed ? <EyeInvisibleOutlined /> : <EyeOutlined />}
                    onClick={() => setRevealed((v) => !v)}
                    aria-label={revealed ? t('Hide') : t('Show')}
                />
            </Tooltip>
            <Tooltip title={t('Copy')}>
                <Button type="link" size="small" icon={<CopyOutlined />} onClick={copy} aria-label={t('Copy')} />
            </Tooltip>
        </Space>
    );
};

export default SecretText;
